import { memo, useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import { unzipSync, strFromU8 } from 'fflate';

// Fetch the .lottie file from S3, unzip in-browser, and return the embedded
// animation JSON. Cached at module level so we only do this once per page load.
// To update the loader animation, replace the .lottie file at this S3 URL.
const IMAGINE_LOADER_URL = 'https://media.imagine.io/media/public/loader/imagine-loader.lottie';
let imagineLoaderPromise = null;

export const loadImagineLoaderAnimation = () => {
  if (!imagineLoaderPromise) {
    imagineLoaderPromise = fetch(IMAGINE_LOADER_URL)
      .then((res) => res.arrayBuffer())
      .then((buf) => {
        const files = unzipSync(new Uint8Array(buf));
        const jsonEntry = Object.entries(files).find(
          ([name]) => name.startsWith('animations/') && name.endsWith('.json')
        );
        if (!jsonEntry) throw new Error('No animation JSON in imagine-loader.lottie');
        return JSON.parse(strFromU8(jsonEntry[1]));
      })
      .catch((err) => {
        // Allow retry on next call if the fetch/unzip failed.
        imagineLoaderPromise = null;
        throw err;
      });
  }
  return imagineLoaderPromise;
};

// Kick the fetch off eagerly so AnimatedLoader almost always has data ready.
loadImagineLoaderAnimation().catch(() => {});

export const AnimatedLoader = memo(({ id = null, show = true, style = {} }) => {
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    loadImagineLoaderAnimation()
      .then((data) => {
        if (!cancelled) setAnimationData(data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  if (!show || !animationData) return null;

  return (
    <div key={id} id={id} style={style}>
      <Lottie
        animationData={animationData}
        loop
        autoplay
        style={{ width: '100%', height: '100%' }}
      />
    </div>
  );
});

export default AnimatedLoader;
